<template>
    <div class="college">
        <div class="top-box">
            <div class="headerTab">
                <span v-for="(item,index) in navTab" :key="index" :class="index==activeNum?'active':''" @click="tabChange(index)">{{item}}</span>
            </div>
            <div class="search-box" v-if="activeNum!=2">
                <el-input placeholder="请输入产品名称" @keyup.native.enter="search" v-model="searchText"></el-input>
                <el-button type="warning" @click="search">查询</el-button>
            </div>
        </div>

        <div class="cphbNav1">
            <span v-for="(item,index) in themeList" :class="index==themeActive?'active':''" :key="index" @click="themeClick(index,item.id)">{{item.name}}</span>
        </div>
        <div class="cpcp" v-show="activeNum==0">
            <div class="item clearfix"  v-for="(item,index) in articlelistData" @click="goArticle(item.id)" :key="index">
                <div class="pic">
                    <img :src="item.img" alt="">
                    <img v-if="item.type == 2" src="@static/images/play.png" class="play" alt="">
                </div>
                <div class="content">
                    <div class="title" :title="item.title">{{item.title}}</div>
                    <div class="desc" :title="item.summary">{{item.summary}}</div>
                    <div class="tag" >
                        <i v-if='item.label'>标签：</i>
                        <span class="tagItem" v-if='item.label' v-for="(labelItem,i) in item.label" :key="i">{{labelItem}}</span>
                    </div>
                    <div class="timeAnum">
                        <span>更新时间：{{item.createTime | timeNum(10)}}</span>
                        <span style="margin-left:50px;">阅读次数：{{item.readNumber}}</span>
                    </div>
                </div>
                <div class="btn">
                    <el-button type="primary" plain>阅读详情</el-button>
                </div>
            </div>
            <el-pagination
                v-if="articlelistData.length>0"
                background
                class="colPage"
                layout="prev, pager, next"
                @current-change='pageChange'
                :page-size='10'
                :total="total">
            </el-pagination>
            <div class="no" v-else>
                <img src="@static/images/no.png" alt="">
                <span>暂无数据</span>
            </div>
        </div>
        <div class="lpal" v-show="activeNum==1">
            <div class="item clearfix" v-for="(item,index) in articlelistData" @click="goArticle(item.id)" :key="index">
                <div class="pic">
                    <img :src="item.img" alt="">
                    <img v-if="item.type == 2" src="@static/images/play.png" class="play" alt="">
                </div>
                <div class="content">
                    <div class="title">{{item.title}}</div>
                    <div class="desc">{{item.summary}}</div>
                    <div class="tag">
                        <i v-if='item.label'>标签：</i>
                        <span v-if='item.label' class="tagItem" v-for="(labelItem,i) in item.label" :key="i">{{labelItem}}</span>
                    </div>
                    <div class="timeAnum">
                        <span>更新时间：{{item.createTime | timeNum(10)}}</span>
                        <span style="margin-left:50px;">阅读次数：{{item.readNumber}}</span>
                    </div>
                </div>
                <div class="btn">
                    <el-button type="primary" plain>阅读详情</el-button>
                </div>
            </div>
            <el-pagination
                v-if="articlelistData.length>0"
                background
                class="colPage"
                layout="prev, pager, next"
                @current-change='pageChange'
                :page-size='10'
                :total="total">
            </el-pagination>
            <div class="no" v-else>
                <img src="@static/images/no.png" alt="">
                <span>暂无数据</span>
            </div>
        </div>
        <div class="cphb" v-if="activeNum==2">
            <div class="cphbNav2">
                <div class="content2 clearfix">
                    <div class="box2" ref='text' :style="{'height':box2H,opacity:opacitys}">
                        <span :class="posterProductActive==index?'active':''"  v-for="(posterProductItem,index) in posterProductList" @click="posterProductClick(index)" :key="index">{{posterProductItem.name}}</span>
                    </div>
                    <span class="more"  @mouseover="moreshow" v-show="moreBtnShow">{{moreWord | subString(6)}}<i class="icon-xialasanjiao"></i></span>
                </div>
                <div class="moreFl" @mouseleave="morehide" v-show="moreFlShow">
                    <div class="marf">
                        <span v-for="(posterProductItem,index) in posterProductList" :key="index" :class="posterProductActive==index?'active':''"
                            @click="posterProductClick(index)">{{posterProductItem.name}}</span>
                    </div>
                </div>
            </div>
            <div class="bgbox clearfix">
                <div class="hbItem" v-for="(posterItem,index) in posterListData" :key="index">
                    <a :href="posterItem.url" target="_blank" class="pic">
                        <img :src="posterItem.url" alt="">
                    </a>
                    <!-- <div class="hbDesc">{{posterItem.name}}</div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    //当前实例组件
    var vm
    export default {
        data: () => ({
           navTab:['产品测评','理赔案例','产品海报'],
           moreWord:'更多',
           activeNum:0,
           searchText:"",
           articlelistData:[],
           themeList:[],
           themeActive:0,
           posterProductActive:0,
           moreFlShow:false,
           posterProductList:[],
           posterListData:[],
           box2H:'',
           box2Show:false,
           opacitys:0,
           moreBtnShow:false,
           total:0,
           types:1
        }),
        created() {
            vm = this
            this.tabChange(0)
        },
        methods: {
            search(){
                this.articlelist(1,this.activeNum+1);
            },
            tabChange:function(i){
                this.activeNum = i
                this.themeActive = 0;
                this.searchText = "";
                if(this.activeNum!=2){
                    this.articlelist(1,this.activeNum+1);
                    this.articleTheme();
                }else{
                    this.posterTheme();
                }
            },
            //产品测评 理赔案例 (type)
            articlelist:function(num,type){
                var that = this;
                vm.types = type
                this.$http({
                    url:'/master/product/article/list',
                    type:'put',
                    params:{
                        pageSize:10,
                        pageNum:num,
                        productName:this.searchText,
                        themeId:this.themeActive==0?"":this.themeList[this.themeActive].id,
                        articleType :type
                    },
                }).then(function(data) {
                    // if(type==1){
                        vm.total = data.total
                    // }
                    for(var i = 0;i<data.data.length;i++){
                        if(data.data[i].label){
                            data.data[i].label = data.data[i].label.split(',')
                        }
                    }
                    vm.articlelistData = data.data
                })
            },
            pageChange:function(nums){
                vm.articlelist(nums,vm.types)
            },
            // 文章产品分类
            articleTheme(){
                this.$http({
                    url:'/master/product/productArticle/themes',
                    type:'put',
                    params:{
                        type:this.activeNum+1
                    },
                }).then(function(data) {
                    if(data.data&&data.data.length){
                        vm.themeList = [{name:"全部"}].concat(data.data)
                    }else{
                        vm.themeList = [{name:"全部"}]
                    }
                })
            },
            //海报产品分类接口
            posterTheme:function(){
                vm.themeActive = 0
                this.$http({
                    url:'/master/product/poster/theme',
                    type:'put',
                    params:{},
                }).then(function(data) {
                    vm.themeList = data.data
                    vm.posterProduct()
                })
            },
            //产品分类点击(一级分类)
            themeClick:function(index,themeId){
                vm.themeActive = index;
                this.searchText = "";
                if(this.activeNum!=2){
                    this.articlelist(1,this.activeNum+1);
                }else{
                    vm.posterProductActive = 0
                    vm.moreFlShow = false;
                    vm.posterProduct()
                }
            },
            //(二级分类)
            posterProduct:function(){
                this.$http({
                    url:'/master/product/poster/product',
                    type:'put',
                    params:{
                        themeId:vm.themeList[vm.themeActive].id
                    },
                }).then(function(data) {
                    vm.posterProductList = data.data
                    vm.opacitys = 0
                    vm.box2H = ''
                    vm.$nextTick(function(){
                        if(vm.$refs.text.clientHeight>30){
                            vm.moreBtnShow = true
                        }else{
                            vm.moreBtnShow = false
                        }
                        console.log(vm.moreBtnShow)
                        console.log(vm.$refs.text.clientHeight)
                        vm.$forceUpdate()
                        vm.opacitys = 1
                        vm.box2H = '30px'
                    })
                    vm.posterList()
                })
            },
            posterProductClick:function(index){
                vm.posterProductActive = index
                vm.posterList()
            },
            //海报
            posterList:function(){
                var that = this
                this.$http({
                    url:'/master/product/poster/list',
                    type:'put',
                    params:{
                        productId:vm.posterProductList[vm.posterProductActive].id
                    },
                }).then(function(data) {
                    that.moreWord = vm.posterProductList[vm.posterProductActive].name
                    if(data.data){
                        var obj = JSON.parse(data.data)
                    }
                    vm.posterListData = obj
                })
            },
            goArticle:function(id){
                window.open('#/article_detail/'+id);
            },
            moreshow:function(){
                vm.moreFlShow = true
            },
            morehide:function(){
                vm.moreFlShow = false
            }
        },
        mounted() {

        }
    };
</script>
<style lang="scss">
    @import "~@/sass/product_m/college";
</style>
